/** Digits and a single decimal point, with at most two places. Leaves "12." intact. */
export function sanitizeMoneyInput(raw) {
  const value = String(raw ?? "").replace(/[^0-9.]/g, "");
  const dot = value.indexOf(".");
  if (dot === -1) return value;
  const whole = value.slice(0, dot);
  const fraction = value.slice(dot + 1).replace(/\./g, "").slice(0, 2);
  return `${whole}.${fraction}`;
}

export function parseMoneyInput(raw) {
  const sanitized = sanitizeMoneyInput(raw);
  if (sanitized === "" || sanitized === ".") return 0;
  const n = Number(sanitized);
  return Number.isFinite(n) ? n : 0;
}

/** Two-decimal display. Call on blur or save, not on each keystroke. */
export function formatMoneyInput(raw) {
  const sanitized = sanitizeMoneyInput(raw);
  if (sanitized === "" || sanitized === ".") return "";
  return parseMoneyInput(sanitized).toFixed(2);
}

export function commitDiscountInput(type, input) {
  const amount = parseMoneyInput(input);
  if (amount <= 0) return "";
  if (type === "percent") {
    const pct = Math.min(amount, 100);
    return Number.isInteger(pct) ? String(pct) : pct.toFixed(2);
  }
  return amount.toFixed(2);
}

export function computeDiscountAmount(serviceTotal, type, input) {
  const base = Math.round(Math.max(0, Number(serviceTotal) || 0) * 100) / 100;
  const raw = parseMoneyInput(input);
  if (raw <= 0 || base <= 0) return 0;
  if (type === "percent") {
    const pct = Math.min(raw, 100);
    return Math.round(base * (pct / 100) * 100) / 100;
  }
  return Math.min(Math.round(raw * 100) / 100, base);
}

export function discountLabel(type, input) {
  if (type !== "percent") return "Discount";
  const committed = commitDiscountInput("percent", input);
  if (!committed) return "Discount";
  const shown = committed.replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
  return `Discount (${shown}%)`;
}
